import ModalVideoPlayer from '@/components/modals/ModalVideoPlayer.vue'
import ModalLetterTips from '@/components/modals/ModalLetterTips.vue'

export const pcModalMap = {
  ModalLetterTips,
  ModalVideoPlayer
};
